import { action, createRequestTypes } from 'utils/actions'

export const SETTINGS_PORTAL_USER_SEARCH_RESULTS = createRequestTypes('SETTINGS_PORTAL_USER_SEARCH_RESULTS')
export const SETTINGS_PARTNER_SEARCH_RESULTS = createRequestTypes('SETTINGS_PARTNER_SEARCH_RESULTS')

export const SETTINGS_SET_CURRENT_PARTNER_ID = 'SETTINGS_SET_CURRENT_PARTNER_ID'
export const SETTINGS_UPDATE = 'SETTINGS_UPDATE'
export const SETTINGS_UPDATE_CURRENT_PARTNER = 'SETTINGS_UPDATE_CURRENT_PARTNER'
export const SETTINGS_UPDATE_PORTAL_USER_SEARCH_RESULTS = 'SETTINGS_UPDATE_PORTAL_USER_SEARCH_RESULTS'
export const SETTINGS_UPDATE_PARTNER_SEARCH_RESULTS = 'SETTINGS_UPDATE_PARTNER_SEARCH_RESULTS'

export const portalUserSearch = {
  request: query => action(SETTINGS_PORTAL_USER_SEARCH_RESULTS.REQUEST, { query }),
  success: (response) => action(SETTINGS_PORTAL_USER_SEARCH_RESULTS.SUCCESS, { response }),
  failure: (error) => action(SETTINGS_PORTAL_USER_SEARCH_RESULTS.FAILURE, { error }),
}
export const partnerSearch = {
  request: query => action(SETTINGS_PARTNER_SEARCH_RESULTS.REQUEST, { query }),
  success: (response) => action(SETTINGS_PARTNER_SEARCH_RESULTS.SUCCESS, { response }),
  failure: (error) => action(SETTINGS_PARTNER_SEARCH_RESULTS.FAILURE, { error }),
}

export const setCurrentPartnerId = partnerId => action(SETTINGS_SET_CURRENT_PARTNER_ID, { partnerId })
export const updateSettings = () => action(SETTINGS_UPDATE)
export const updateCurrentPartnerSettings = () => action(SETTINGS_UPDATE_CURRENT_PARTNER)
export const updatePortalUserSearchResults = query => action(SETTINGS_UPDATE_PORTAL_USER_SEARCH_RESULTS, { query })
export const updatePartnerSearchResults = query => action(SETTINGS_UPDATE_PARTNER_SEARCH_RESULTS, { query })



/** WEBPACK FOOTER **
 ** ./src/actions/settings/settings-actions.js
 **/